var map = {
	"./bg.json": [
		1204,
		386
	],
	"./cs.json": [
		1205,
		385
	],
	"./da.json": [
		1206,
		384
	],
	"./de.json": [
		1207,
		383
	],
	"./el.json": [
		1208,
		382
	],
	"./en.json": [
		162
	],
	"./es.json": [
		1209,
		381
	],
	"./fr.json": [
		1210,
		380
	],
	"./hr.json": [
		1211,
		379
	],
	"./hu.json": [
		1212,
		378
	],
	"./id.json": [
		1213,
		377
	],
	"./it.json": [
		1214,
		376
	],
	"./ko.json": [
		1215,
		375
	],
	"./nl.json": [
		1216,
		374
	],
	"./pt-BR.json": [
		1217,
		373
	],
	"./pt.json": [
		1218,
		372
	],
	"./ro.json": [
		1219,
		371
	],
	"./ru.json": [
		1220,
		370
	],
	"./sv.json": [
		1221,
		369
	],
	"./tr.json": [
		1222,
		368
	],
	"./zh-CN.json": [
		1223,
		367
	],
	"./zh-tw.json": [
		1224,
		366
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 963;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/translations lazy ^\.\/.*\.json$
// module id = 963
// module chunks = 388